import { EmailVariantIcon } from './EmailVariantIcon';

/**
 * author: Austin Andrews
 * id 80BB05EB-8F75-4205-9952-60B09204A9F6
 * name email-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-variant.svg
 * tags
 */
export const EnvelopeVariantIcon = EmailVariantIcon;
export default EnvelopeVariantIcon